// import React, { useState } from 'react';
// import './WhatsAppChat.css';

// const WhatsAppChat = () => {
//     const [linkClicked, setLinkClicked] = useState(false);

//     const handleClick = () => {
//         setLinkClicked(true);
//         window.open(
//             'https://wa.me/918576891104?text=Hi%20there!%20I%20want%20to%20schedule%20a%20meeting',
//             '_blank',
//             'noopener,noreferrer'
//         );
//     };

//     return (
//         <div className="whatsapp-float" onClick={handleClick} role="button">
//             {!linkClicked && (
//                 <>
//                     <img
//                         src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
//                         alt="WhatsApp Chat"
//                         className="whatsapp-icon"
//                         loading="lazy"
//                     />
//                     <h3 className="whatsapp-label">Live Chat</h3>
//                 </>
//             )}
//         </div>
//     );
// };

// export default WhatsAppChat;
import React, { useState } from "react";
import "./WhatsAppChat.css";

const WhatsAppChat = () => {
  const [showOptions, setShowOptions] = useState(false);

  const handleWhatsAppClick = (number) => {
    window.open(
      `https://wa.me/${number}?text=Hi%20there!%20I%20want%20to%20schedule%20a%20meeting`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <>
      {showOptions && (
        <div className="whatsapp-options">
          <button
            className="whatsapp-option-btn"
            onClick={() => handleWhatsAppClick("919582646647")}
          >
            💬 Inquiry
          </button>

          <button
            className="whatsapp-option-btn"
            onClick={() => handleWhatsAppClick("918576891104")}
          >
            🎧 Support
          </button>
        </div>
      )}

      <div
        className="whatsapp-float"
        onClick={() => setShowOptions(!showOptions)}
        role="button"
      >
        <>
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
            alt="WhatsApp Chat"
            className="whatsapp-icon"
            loading="lazy"
          />
          <h3 className="whatsapp-label">Live Chat</h3>
        </>
      </div>
    </>
  );
};

export default WhatsAppChat;
